import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import './App.css';

// Components
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import DashboardFooter from './components/DashboardFooter';
import PublicHome from './components/Public/PublicHome';
import NoticesPage from './components/Public/NoticesPage';
import NoticeDetails from './components/Public/NoticeDetails';
import VideoGallery from './components/Public/VideoGallery';
import ImageGalleryList from './components/Public/ImageGalleryList';
import ImageGalleryAlbum from './components/Public/ImageGalleryAlbum';
import Login from './components/Auth/Login';
import Register from './components/Auth/Register';
import ResidentDashboard from './components/Resident/ResidentDashboard';
import ManagerDashboard from './components/Manager/Dashboard';
import AdminRouter from './components/Admin/AdminRouter';
import UserProfile from './components/UserProfile';
import ProtectedRoute from './components/ProtectedRoute';
import DashboardLayout from './components/Dashboard/DashboardLayout';
import UserDashboard from './components/Dashboard/UserDashboard';

function AppContent() {
  const location = useLocation();
  
  // Show full footer only on public routes
  const showFooter = location.pathname === '/' || 
                    location.pathname === '/login' || 
                    location.pathname === '/register' ||
                    location.pathname.startsWith('/notices') ||
                    location.pathname.startsWith('/videos') ||
                    location.pathname.startsWith('/galleries');
  
  // Show dashboard footer on dashboard routes
  const showDashboardFooter = location.pathname.startsWith('/resident') || 
                              location.pathname.startsWith('/manager') || 
                              location.pathname.startsWith('/admin') ||
                              location.pathname.startsWith('/profile');

  return (
    <div className="App">
      <Navbar />
      <Routes>
        {/* Public Routes */}
        <Route path="/" element={<PublicHome />} />
        <Route path="/notices" element={<NoticesPage />} />
        <Route path="/notices/:id" element={<NoticeDetails />} />
        <Route path="/videos" element={<VideoGallery />} />
        <Route path="/galleries" element={<ImageGalleryList />} />
        <Route path="/galleries/:id" element={<ImageGalleryAlbum />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        
        {/* Protected Routes */}
        <Route path="/resident/*" element={
          <ProtectedRoute allowedRoles={['resident']}>
            <ResidentDashboard />
          </ProtectedRoute>
        } />
        
        <Route path="/manager/*" element={
          <ProtectedRoute allowedRoles={['manager', 'building_committee']}>
            <ManagerDashboard />
          </ProtectedRoute>
        } />
        
        <Route path="/admin/*" element={
          <ProtectedRoute allowedRoles={['admin', 'central_committee']}>
            <AdminRouter />
          </ProtectedRoute>
        } />
        
        <Route path="/dashboard" element={
          <ProtectedRoute allowedRoles={['admin', 'central_committee', 'building_committee', 'manager', 'resident', 'visitor']}>
            <DashboardLayout>
              <UserDashboard />
            </DashboardLayout>
          </ProtectedRoute>
        } />
        
        <Route path="/profile" element={
          <ProtectedRoute allowedRoles={['admin', 'central_committee', 'building_committee', 'manager', 'resident', 'visitor']}>
            <DashboardLayout>
              <UserProfile />
            </DashboardLayout>
          </ProtectedRoute>
        } />
      </Routes>
      {showFooter && <Footer />}
      {showDashboardFooter && <DashboardFooter />}
    </div>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
